
            const data = {"name":"star","data":{"width":"17","height":"16","viewBox":"0 0 17 16","data":"<path pid=\"0\" d=\"m8.674.153 1.913 5.888h6.19L11.77 9.679l1.913 5.888-5.008-3.639-5.008 3.639 1.913-5.888L.57 6.041h6.19L8.675.153Z\" _fill=\"#fff\"/>","originalColors":[{"type":"fill","color":"#fff"}],"stopColors":[]}}
        
                    module.exports = data
                    